
import { Injectable } from '@angular/core';
import { Pontuacao } from './pontuacao';
import { Observable } from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { HttpService } from 'ems-oauth2-client';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';
import { PontuacaoResultadoVo } from '../pontuacao-resultado/pontuacao-resultado.vo';

@Injectable()
export class PontuacaoService extends ServiceUtil  {
    private url = '/sae/pontuacao';

    constructor(private http: HttpService, private pagerComponent: PagerComponent) { super(); }

    // altera ou inclui Pontuacao
    update(pontuacao: Pontuacao): Observable<Pontuacao> {
        const body = JSON.stringify(pontuacao);
        if (!pontuacao.id) {
          return this.http.post(this.url, body)
            .pipe(map(response => <Pontuacao> response),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
        } else {
          return this.http.put(this.url + '/' + pontuacao.id , body)
            .pipe(map(response => <Pontuacao> response),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
        }
    }

    // deleta Pontuacao
    deletar(pontuacao: Pontuacao): Observable<Pontuacao> {
      return this.http.delete(this.url + '/' + pontuacao.id)
        .pipe(map(response => response),
           catchError(this.handleError),
           publishReplay(1),
           refCount());
    }

    // lista todos (sem filtro)
    listar(): Observable<Pontuacao[]> {
      return this.http.get(this.url)
            .pipe(map(this.extractListData),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
    }


    // filtra
    filtrar(filtro: Pontuacao): Observable<Pontuacao[]> {
      let colocaVirgula = false;
      let novaUrl = '{';
      if (filtro.codigoEstudoSocioEconomico) {
       novaUrl += 'codigoEstudoSocioEconomico:\'' + filtro.codigoEstudoSocioEconomico + '\'';
       colocaVirgula = true;
      }
      novaUrl +=  '}';

      const urlModify = this.pagerComponent.formatarUrl(this.url, novaUrl, 100, 0);

      return this.http.get(urlModify)
              .pipe(map(response => {
                  return <Pontuacao[]> response;
              }),
                 catchError(this.handleError),
                 publishReplay(1),
                 refCount());
    }

    // recupera por id
    getId(id: number): Observable<Pontuacao> {
        return this.http.get(this.url + '/' + id)
                  .pipe(map(this.extractObjectData),
                     catchError(this.handleError),
                     publishReplay(1),
                     refCount());
    }

    realizarPontuacao(idEstudo: number, membroSelecionados: number[]): Observable<Pontuacao> {
      let parametros;
      let url = this.url + '/calcular/' + idEstudo;
      if (membroSelecionados && membroSelecionados.length > 0) {
        parametros = '?parametro=\"';
        parametros += JSON.stringify(membroSelecionados) + '\"';
      }
      if (parametros) {
         url += parametros;
      }


      return this.http.get(url)
      .pipe(map(this.extractObjectData),
          catchError(this.handleError),
          publishReplay(1),
          refCount());

    }

    encerrarPontuacao(pontuacao: Pontuacao): Observable<Pontuacao> {
      pontuacao.beneficios = undefined;
      const body = JSON.stringify(pontuacao);

      return this.http.put(this.url + '/' + pontuacao.id + '/encerrar', body)
      .pipe(map(response => <Pontuacao> response),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
    }

    pontuacaoResultado(matricula: string): Observable<PontuacaoResultadoVo[]> {
      return this.http.get(this.url + '/resultado/?matricula=\"' + matricula + '\"')
                .pipe(map(response =>  <PontuacaoResultadoVo[]> response),
                    catchError(this.handleError),
                    publishReplay(1),
                    refCount());
    }

    // extrai lista da resposta http
    private extractListData(res: any) {
      return res as Pontuacao[] ;
    }

    // extrai objeto da resposta http
    private extractObjectData(res: any) {
      return res as Pontuacao ;
    }
}
